/**
 * Cobertura mínima requerida, expresada como fracción sobre la cantidad de la orden.
 * La suma de las bolsas debe ESTRICTAMENTE superar este valor — es decir, cubrir
 * la cantidad de la orden con un margen mayor al 10% (según spec ODD).
 */
export const SILO_BAG_COVERAGE_MARGIN = 1.10;

/**
 * Sobre-cobertura, expresada como fracción sobre la cobertura MÍNIMA (no sobre la orden).
 * Si la suma de las bolsas supera este valor se muestra una alerta informativa: no invalida
 * la selección, sólo avisa que se está comprometiendo bastante más grano del necesario.
 */
export const SILO_BAG_OVER_COVERAGE_MARGIN = 1.30;
